import { ChatGptRole } from '../services/StoryGeneratorService/ChatGpt.types';
export const STICKY_HEADER_SCROLL_THRESHOLD = 5;
export const STICKY_HEADER_SCROLL_DEBOUCE_THRESHOLD = 100;
export const MAX_GENERATION_TOKEN = 3000;
export const MAX_ENHANCED_PROMPT_TOKEN = 750;
export const SMALL_MODEL_PROMPT_WORD_THRESHOLD = 1000;
export const NO_EPIC_KEY = 'NO_EPIC';
export const JIRA_EPIC_KEY = 'JIRA_EPIC';
export const EPIC_ID_PREFIX = 'epic';
export const STORY_ID_PREFIX = 'story';
export const TASK_ID_PREFIX = 'task';
export const DESCRIPTION_KEY = 'description';
export const SUMMARY_KEY = 'summary';
export const EPIC_ID = 'epic_id';
export const ID_KEY = 'id';
export const PUBLISH_JIRA_LABEL = 'storygenie';
export const PROMPT_INPUT_ENHANCER_THRESHOLD = 2;
export const PROMPT_RESULT_SCROLL_TIMEOUT = 500;
export const PROMPT_RESULT_HIGHLIGHT_TIMEOUT = 3000;
export const RESPONSE_FORMAT = {"type": "json_object"};
export const ISSUE_TYPES = {
  EPIC: 'Epic',
  STORY: 'Story',
  TASK: 'Task'
};

export const AI_MODELS = {
  GPT_4O: 'gpt-4o',
  GPT_4: 'gpt-4',
  GPT_5_1: 'gpt-5.1',
  GPT_5_1_MINI: 'gpt-5.1-mini',
  GEMINI_2_5: 'gemini-2.5',
  GEMINI_3: 'gemini-3',
  CLAUDE_4_5_SONNET: 'claude-4.5-sonnet'
};

export const WORK_ITEM_VOLUME_OPTIONS = [
  { value: 'low', label: 'Lean' },
  { value: 'medium', label: 'Standard' },
  { value: 'high', label: 'Comprehensive' }
];

export const CHAT_GPT = {
  ROLE_DEFAULT: 'user',
  ROLE_SYSTEM: 'system',
  MODEL_3: 'gpt-3.5-turbo',
  MODEL_4: 'gpt-4',
  MODEL_4_128: 'gpt-4-1106-preview',
  MODEL_4o: 'gpt-4o',
  TEMPERATURE: 0,
  SYSTEM_MESSAGES: {
    EPICS_AND_USER_STORIES: [
      {
        role: ChatGptRole.System,
        content:
          'You are an AI model trained to generate Epics and User Stories for broad agile projects that can be imported into Jira, based on user provided project descriptions and requirements.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The user will provide a short project overview or specific requirements. Your task is to decompose and elaborate on this input, generating a comprehensive set of Epics and User Stories for an Agile project.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Ensure that your response covers all aspects of the features, providing a complete and comprehensive set of user stories from the users prompt.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The Summary field for Stories should be in short title form (E.g. Content Streaming and On-Demand Access) and MUST NOT contain "As a [role], I want to... so that....". Additionally the Description field must be in the "As a [role], I want to... so that...." format elaborating the Summary field.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Stictly no additional commentary on the top or bottom of the outline of the features or requirements.'
      }
    ],
    USER_STORIES: [
      {
        role: ChatGptRole.System,
        content:
          'You are an agile product manager responsible for writing User Stories for the applications development team that will be imported into Jira.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The Summary field for Stories should be in short title form (E.g. Content Streaming and On-Demand Access) and MUST NOT contain "As a [role], I want to... so that....". Additionally the Description field must be in the "As a [role], I want to... so that...." format elaborating the Summary field.'
      },
      {
        role: ChatGptRole.User,
        content:
          'I will provide a paragraph or bullet points in subsequent prompts that you should decompose and expand into multiple User stories as necessary to provide a good level of granularity for the development team to estimate.'
      }
    ],
    EPICS: [
      {
        role: ChatGptRole.System,
        content:
          'You are an agile product manager responsible for writing Epics for the applications development team that will be imported into Jira.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Each Epic must have a Summary & Description fields.The Summary field should be in short title form, And the Description field should be a more expansive, long-form elaboration of the summary field.'
      },
      {
        role: ChatGptRole.User,
        content:
          'I will provide a paragraph or bullet points in subsequent prompts that you should decompose and expand into multiple Epics as necessary to provide a good level of granularity for the development team to estimate.'
      }
    ],
    ENHANCED_PROMPT: [
      {
        role: ChatGptRole.System,
        content:
          'You are an AI model trained to generate a full collection of features outline in the form of a bullet point list for agile projects, based on provided project descriptions and requirements.'
      },
      {
        role: ChatGptRole.System,
        content:
          'You will receive a brief project overview or a set of requirements from the user. Your task is to create a full and comprehensive outline consisting of main points, and sub-points within each main point.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Ensure that your response covers all aspects of the features, providing a well-rounded, comprehensive and detailed set of features. Provide as many main points and sub-points as possible for completeness.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Stictly no additional commentary on the top or bottom of the outline of the features or requirements.'
      },
      {
        role: ChatGptRole.System,
        content:
          "The format of the outline must be striclty a two-level hierarchy of a heading and bullet points. Don't use roman numberals. Format template example: [1.Heading:\n- Bullet point\n- Bullet point\n2.Heading:\n- Bullet point\n- Bullet point]."
      }
    ],
    SINGLE_EPIC: [
      {
        role: ChatGptRole.System,
        content:
          'You are an AI model trained to generate well written and fully formed Epics for agile projects, based on descriptions and requirements provided in user messages.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The user will provide a short overview of the requirements or features. Your task is to decompose and elaborate on this input, and then generate a comprehensive description and bullet point outline of the features that will be used as an Epic description.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Avoid any additional commentary on the top or bottom of your description and outline of the features or requirements.'
      },
      {
        role: ChatGptRole.System,
        content:
          "Avoid the use of any special characters such as '##' or '**' to denote outline levels or headings."
      }
    ],
    SINGLE_STORY: [
      {
        role: ChatGptRole.System,
        content:
          'You are an AI model trained to generate well written and fully formed User Stories for agile projects, based on descriptions and requirements provided in user messages.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The user will provide a short overview of the requirements or features. Your task is to decompose and elaborate on this input, and then generate a comprehensive description and bullet point outline of the features that will be used as a User Story description.'
      },
      {
        role: ChatGptRole.System,
        content:
          'Avoid any additional commentary on the top or bottom of your description and outline of the features or requirements.'
      },
      {
        role: ChatGptRole.System,
        content:
          "Avoid the use of any special characters such as '##' or '**' to denote outline levels or headings."
      }
    ],
    SINGLE_EPIC_AND_USER_STORIES: [
      {
        role: ChatGptRole.System,
        content:
          'You are an agile product manager responsible for writing a single Epic and a comprehensive set of user stories under this Epic for the development team that will be imported into Jira.'
      },
      {
        role: ChatGptRole.System,
        content: 'The Epic and its stories must have a Summary & Description field.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The Summary field for the single Epic should be in short title form, and the Description field should be a more expansive, long-form elaboration of the Summary field.'
      },
      {
        role: ChatGptRole.System,
        content:
          'The Summary field for Stories should be in short title form and must not contain "As a [role], I want to... so that....". And The Description field must be in the "As a [role], I want to... so that...." format elaborating the Summary field'
      },
      {
        role: ChatGptRole.User,
        content:
          'I  will provide a paragraph or bullet points in subsequent prompts that you should decompose into a single Epic and multiple User stories as necessary to provide a good level of granularity for the development team to estimate.'
      }
    ],
    FORMAT: {
      EPICS_AND_USER_STORIES:
        'Return JSON in a single-line without whitespaces using this template: {"epics":{"id":{"s":"EpicSummary","d":"EpicDescription", "stories":{"id":{"s":"StorySummary","d":"StoryDescription"}}}}}. Story IDs follow the format \'{id}\' (starting from {0}) and epic IDs follow the format \'{id}\' (starting from {1}). All epic and story IDs in the JSON MUST be unique.',
      BULK_STORIES:
        'Provide response in a valid single JSON object format without whitespaces (single parent object should contain all stories) using this template: "{"story_id": {"s" : "Summary","d": "Description"}}" Story IDs follow the format \'{id}\' (starting from {0})',
      BULK_EPICS:
        'Provide response in a valid single JSON object format without whitespaces (single parent object should contain all epics) using this template: "{"epic_id": {"s": "Summary","d": "Description"}}" Epic IDs follow the format \'{id}\' (starting from {0})',
      SINGLE_EPIC:
        'Provide response in a valid JSON format without whitespaces using this template: "{"summary": "Summary","description": "Description"}"',
      SINGLE_STORY:
        'Provide response in a valid JSON format without whitespaces using this template: "{"summary": "Summary","description": "Description"}"',
      SINGLE_EPIC_MULTIPLE_STORIES:
        'Provide response in a valid single JSON object format without whitespaces using this template: { epic:{"s":"EpicSummary","d":"EpicDescription"},"stories":{"story_id":{"s":"StorySummary","d":"StoryDescription"}}}. Story IDs follow the format "story_{id}" (starting from {0}) and single epic with summary and description.'
    },
    DONT_PROVIDE_ADDITIONAL_COMMENTRY: {
      role: ChatGptRole.User,
      content:
        "Avoid any additional commentary  on the top or bottom of your description and outline of the features or requirements and ensure the response JSON doesn't contain any unexpected non-whitespace characters. Avoid unnecessary new breaks and blank space in the response"
    }
  }
};

/**
 * Task-specific system messages for generating Tasks
 * Tasks are smaller, actionable work items that can typically be completed in hours to a day
 */
export const TASK_SYSTEM_MESSAGES = {
  MULTIPLE_TASKS: [
    {
      role: ChatGptRole.System,
      content:
        'You are an agile product manager responsible for writing Tasks for the development team that will be imported into Jira.'
    },
    {
      role: ChatGptRole.System,
      content:
        'Tasks should be small, actionable work items that can typically be completed in hours to a day.'
    },
    {
      role: ChatGptRole.System,
      content:
        'Each Task must have a Summary & Description field. The Summary should be a clear, actionable title. The Description should provide implementation details.'
    }
  ],
  SINGLE_TASK: [
    {
      role: ChatGptRole.System,
      content:
        'You are an AI model trained to generate well-written Tasks for agile projects.'
    },
    {
      role: ChatGptRole.System,
      content:
        'Generate a single, detailed task with clear acceptance criteria and implementation steps. Include acceptance criteria and implementation steps inside the Description text only, and do not add extra JSON fields beyond summary and description.'
    }
  ],
  EPICS_AND_TASKS: [
    {
      role: ChatGptRole.System,
      content:
        'You are an agile product manager generating Epics with associated Tasks for a development team.'
    },
    {
      role: ChatGptRole.System,
      content:
        'Each Epic should have multiple Tasks underneath it. Tasks are smaller, actionable items.'
    }
  ],
  SINGLE_EPIC_AND_TASKS: [
    {
      role: ChatGptRole.System,
      content:
        'Generate a single comprehensive Epic with multiple detailed Tasks underneath.'
    }
  ],
  STORIES_AND_TASKS: [
    {
      role: ChatGptRole.System,
      content:
        'You are an agile product manager generating User Stories with associated Tasks for a development team.'
    },
    {
      role: ChatGptRole.System,
      content:
        'Each Story should have multiple Tasks underneath it. Stories define what to deliver; tasks define how to deliver it.'
    }
  ],
  SINGLE_STORY_AND_TASKS: [
    {
      role: ChatGptRole.System,
      content:
        'Generate a single User Story with detailed Tasks that break down the implementation work.'
    }
  ],
  FORMAT: {
    BULK_TASKS:
      'Provide response in a valid single JSON object format without whitespaces using this template: "{"task_id": {"s": "Summary","d": "Description"}}" Task IDs follow the format \'{id}\' (starting from {0})',
    SINGLE_TASK:
      'Provide response in a valid JSON format without whitespaces using this template: "{"summary": "Summary","description": "Description"}"',
    EPICS_AND_TASKS:
      'Return JSON using this template: {"epics":{"id":{"s":"EpicSummary","d":"EpicDescription","tasks":{"id":{"s":"TaskSummary","d":"TaskDescription"}}}}}',
    SINGLE_EPIC_MULTIPLE_TASKS:
      'Return JSON using this template: {"epic":{"s":"EpicSummary","d":"EpicDescription"},"tasks":{"task_id":{"s":"TaskSummary","d":"TaskDescription"}}}',
    STORIES_AND_TASKS:
      'Return JSON using this template: {"stories":{"id":{"s":"StorySummary","d":"StoryDescription","tasks":{"id":{"s":"TaskSummary","d":"TaskDescription"}}}}}',
    SINGLE_STORY_MULTIPLE_TASKS:
      'Return JSON using this template: {"story":{"s":"StorySummary","d":"StoryDescription"},"tasks":{"task_id":{"s":"TaskSummary","d":"TaskDescription"}}}'
  },
  DONT_PROVIDE_ADDITIONAL_COMMENTRY: {
    role: ChatGptRole.User,
    content:
      "Avoid any additional commentary on the top or bottom of your description and ensure the response JSON doesn't contain any unexpected characters. Avoid unnecessary line breaks and blank space in the response"
  }
};

export const DEVICE_RESOLUTION_BREAKPOINT = 900;
export const DEVICE_HEIGHT_BREAKPOINT = 648;
export const MAX_EPICS_TO_LOAD = 1000;
export const GENERIC_JIRA_ERROR_STATUS = 'JIRA_DEFAULT_ERROR';
export const ISSUE_PUBLISH_COUNT_THRESHOLD = 30;
